export enum RecurringTypes {
  none = 'none',
  weekly = 'weekly',
  biweekly = 'biweekly',
  monthly = 'monthly',
}
